var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Text } from "native-base";
import { useAppConfig } from "@madmedical/config";
import { useTranslation } from "@madmedical/i18n";
import openExternalUrl from "../util/openExternalUrl";
import Alert from "../molecules/Alert";
const AppDownloadAlert = (_a) => {
    var { onDismiss } = _a, boxProps = __rest(_a, ["onDismiss"]);
    const { appStoreUrl, googlePlayUrl } = useAppConfig();
    const { t } = useTranslation();
    const handleStorePress = (platform) => () => {
        openExternalUrl(platform === "ios" ? appStoreUrl : googlePlayUrl);
    };
    return (_jsx(Box, Object.assign({}, boxProps, { children: _jsx(Alert, { status: "info", title: t("connectDevice"), description: t("connectDeviceWithTdoc"), onDismiss: onDismiss, links: [
                { text: "App Store", onPress: handleStorePress("ios") },
                {
                    text: "Google Play",
                    onPress: handleStorePress("android"),
                },
            ], linkSeparator: _jsx(Text, Object.assign({ fontSize: "sm", color: "gray.500", alignSelf: "flex-end" }, { children: t("or") })) }) })));
};
export default AppDownloadAlert;
